module.exports = __webpack_public_path__ + "static/media/Buff.d8e3d4af.webm";